import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Card, CardBody, CardFooter, CardHeader, ListGroup, ListGroupItem } from "reactstrap";
import { useEtim } from "../../context/ETIMContext";
import { Link } from "react-router-dom";

export default function EtimProgress({ activeItem, items, onNext, onPrevious }) {
  const { etim,  } = useEtim();

  const itemKeys = Object.keys(items);

  return (
    <Card className="product-progress">
      <CardHeader>
        <FormattedMessage id="etim.edit_title" defaultMessage="Edit series ETIM Class" />
      </CardHeader>

      <CardBody className="p-0">
        <ListGroup flush>
          {itemKeys.map((key, i) => (
            <ListGroupItem
              key={i}
              className={`${items[key].name == activeItem ? "active" : ""} d-flex align-items-center`}
              to={items[key].to}
              disabled={items[key].disabled || false}
              style={{ cursor: "default" }}
              tag={Link}
              onClick={items[key].onclick || (() => {})}
            >
              <span className="flex-grow-1">
                {i + 1}. {items[key].description}
              </span>
            </ListGroupItem>
          ))}
        </ListGroup>
      </CardBody>
      <CardFooter>
        {onNext && (
          <button className="btn btn-outline-dark float-right" onClick={onNext} disabled={etim.classEtim == null || etim.classEtim == ""}>
            <FormattedMessage id="app.next" defaultMessage="Next" />
          </button>
        )}
        {onPrevious && (
          <button type="button" className="btn btn-outline-danger" onClick={onPrevious}>
            <i className="fas fa-arrow-left"></i> <FormattedMessage id="app.back" defaultMessage="Back" />
          </button>
        )}
      </CardFooter>
    </Card>
  );
}
